import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Primary } from "@cinch-labs/design-system";
import { Field, Form } from "react-final-form";
import styles from "./search-form.module.css";
import TextFieldWrapper from "./text-field-search";
export var SearchForm = function(param) {
    var onSubmit = param.onSubmit, _initialValues = param.initialValues, initialValues = _initialValues === void 0 ? {} : _initialValues, isPending = param.isPending;
    return /*#__PURE__*/ _jsx(Form, {
        onSubmit: onSubmit,
        initialValues: initialValues,
        render: function(param) {
            var handleSubmit = param.handleSubmit, pristine = param.pristine;
            return /*#__PURE__*/ _jsxs("form", {
                name: "jargon-search",
                onSubmit: handleSubmit,
                className: styles.form,
                children: [
                    /*#__PURE__*/ _jsx(Field, {
                        id: "searchInput",
                        name: "search",
                        type: "search",
                        component: TextFieldWrapper,
                        label: "I want to understand",
                        autoComplete: "off",
                        placeholder: "E.g. Car Insurance",
                        fullWidth: true
                    }),
                    /*#__PURE__*/ _jsx(Primary, {
                        classNames: {
                            button: styles.button
                        },
                        type: "submit",
                        disabled: pristine || isPending,
                        isLoading: isPending,
                        children: "Search"
                    })
                ]
            });
        }
    });
};
